import { z } from 'zod';
/** Admin tables use offset pagination with totals (ADR-0014). */
export const ADMIN_PAGE_DEFAULT_LIMIT = 20;
export const ADMIN_PAGE_MAX_LIMIT = 100;
/** App feeds use opaque cursors (ADR-0014). */
export const APP_CURSOR_DEFAULT_LIMIT = 10;
export const APP_CURSOR_MAX_LIMIT = 30;
/** `?page=1&limit=20` on `/v1/admin` list endpoints. Extend with resource filters. */
export const AdminPageQuerySchema = z.strictObject({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(ADMIN_PAGE_MAX_LIMIT).default(ADMIN_PAGE_DEFAULT_LIMIT),
});
/** `?sort=<field>&order=asc|desc` on admin lists whose table sorts (each list names its fields). */
export const SORT_ORDERS = ['asc', 'desc'];
export const SortOrderSchema = z.enum(SORT_ORDERS);
/** Admin list shape `{ items, page, limit, total }` (05-api-specification.md § Response standards). */
export const adminPage = (item) => z.object({
    items: z.array(item),
    page: z.number().int().min(1),
    limit: z.number().int().min(1).max(ADMIN_PAGE_MAX_LIMIT),
    total: z.number().int().min(0),
});
/** `?cursor=<opaque>&limit=10` on `/v1/app` feed endpoints. Extend with resource filters. */
export const AppCursorQuerySchema = z.strictObject({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().min(1).max(APP_CURSOR_MAX_LIMIT).default(APP_CURSOR_DEFAULT_LIMIT),
});
/** App list shape `{ items, nextCursor }`; `nextCursor: null` hides Load More. */
export const appCursorPage = (item) => z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=pagination.js.map